import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

function RouteStateGuard({ redirect, children }) {
  const location = useLocation()
  return !location.state || Object.keys(location.state).length === 0 ? <Navigate to={redirect} replace /> : children
}

export default RouteStateGuard
